import { render, staticRenderFns } from "./product_translate.vue?vue&type=template&id=125219d6&scoped=true&"
import script from "./product_translate.vue?vue&type=script&lang=js&"
export * from "./product_translate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125219d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125219d6')) {
      api.createRecord('125219d6', component.options)
    } else {
      api.reload('125219d6', component.options)
    }
    module.hot.accept("./product_translate.vue?vue&type=template&id=125219d6&scoped=true&", function () {
      api.rerender('125219d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/tabs/product_translate.vue"
export default component.exports